<template>
  <div>
    <v-row>
      <v-col
        class="noYPadding"
      >
        <VTextField
          v-model="probe.name"
          outlined
          class="probe"
          hideDetails
          :label="$t('controller.probe.name')"
          :data-cy="`probeName-${probe.name}`"
          @input="updateData"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="noYPadding"
      >
        <VTextField
          v-model="probe.probeId"
          :label="$t('forms.labels.id')"
          :data-cy="`probeId-${probe.probeId}`"
          class="probe-id"
          outlined
          hideDetails
          @input="updateData"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    name: 'ProbeForm',
    components: {
        VTextField,
    },
    props: {
        probe: {
            type: Object,
            default: () => {},
        },
        editMode: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentProbe: {
                name: '',
                probeId: '',
                id: undefined,
                analysisType: '',
                component: '',
            },

        };
    },
    watch: {
        probe: {
            handler() {
                this.$emit('sendData', this.probe);
            },
            deep: true,
            immediate: true,
        },
    },
    created() {
        this.currentProbe = this.probe;
        // conditionally convert the objects to mongo ids
        if (this.probe.analysisType) {
            this.currentProbe.analysisType = this.probe.analysisType.id;
        }
        if (this.probe.component) {
            this.currentProbe.component = this.probe.component.id;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.currentProbe);
        },
    },
};
</script>
<style lang="scss" scoped>
.noYPadding {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
}
.probe {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.probe-id {
    display: flex;
    flex-direction: column;
    width: 100%;
}
.text {
    font-size: 18px;
}
.float-right {
    display: flex;
}
.float-right {
    margin-top: 32px;
    .v-icon {
        width: 5px;
        height: 5px;
        padding: 15px;
    }

    .btn-icon {
        min-width: 30px;
        min-height: 30px;
        padding: 0;
    }
}
</style>
